import PropTypes from "prop-types";
import { Typography } from "@mui/material";

const CatalogDatabaseStatus = ({ databaseName = "unknown" }) => {
  const normalized = String(databaseName || "unknown").trim() || "unknown";

  return (
    <div className="cm-database-status cm-schedule-next-run cm-schedule-next-run--status-only" aria-live="polite">
      <Typography className="cm-schedule-next-run-label" component="span">
        DATABASE CONNESSO:
      </Typography>
      <Typography className="cm-schedule-next-run-value" component="span">
        {normalized}
      </Typography>
    </div>
  );
};

CatalogDatabaseStatus.propTypes = {
  databaseName: PropTypes.string,
};

export default CatalogDatabaseStatus;
